<style scoped>

.btns-action {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}
</style>

<template>
    <register-container :step="step">
        <div class="card-body">
            <h1 class="head-title text-center font-weight-bold">
                Licence
            </h1>
            <p class="text-center mb-5">Upload the licence details below. If your trade <br> does not require licence,
                then you can SKIP this step.</p>

            <b-form
                @submit.prevent="formSubmitted"
                @keydown="form.onKeydown($event)"
            >

                <div
                    v-for="(licence, idx) in form.licences"
                    :key="idx"
                    class="row"
                    style="position: relative"
                >
                    <SvgIcons
                        v-if="idx > 0 && licence.licence_status != 'verified'"
                        icon="insurance-document-close"
                        svgClass="ml-2"
                        style="margin-top: 2px; position: absolute; right: -25"
                        @click.native="deleteLicence(licence)"
                    />
                    <b-col md="6">
                        <b-form-group label="Type of Licence">
                            <b-form-select
                                v-model="licence.licence_type"
                                :disabled="licence.licence_status == 'verified'"
                                :options="licenceTypes"
                                v-bind:class="{
                        'is-invalid': licence.error.errors.licence_type,
                      }"
                            ></b-form-select>
                            <div
                                class="help-block invalid-feedback"
                                v-if="licence.error.errors.licence_type"
                            >
                                {{ licence.error.errors.licence_type[0] }}
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Licence Number">
                            <b-form-input
                                :disabled="licence.licence_status == 'verified'"
                                v-model="licence.licence_number"
                                v-bind:class="{
                        'is-invalid': licence.error.errors.licence_number,
                      }"
                            ></b-form-input>
                            <div
                                class="help-block invalid-feedback"
                                v-if="licence.error.errors.licence_number"
                            >
                                {{ licence.error.errors.licence_number[0] }}
                            </div>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group class="position-relative tobe">
                            <b-form-file
                                placeholder="Upload Documents"
                                multiple
                                :disabled="licence.licence_status == 'verified'"
                                @change="
                        attachLicenceFiles(
                          $event,
                          licence.licence_files,
                          licence.id
                        )
                      "
                                v-bind:class="{
                        'is-invalid': licence.error.errors.licence_files,
                      }"
                            ></b-form-file>

                            <label class="upload-tab">
                                <SvgIcons
                                    icon="upload-document-button"
                                    width="25px"
                                    height="20px"
                                    svgClass="upload-docs"
                                />

                                <span
                                    class="upload-instruction">Allowed file types .pdf, .doc. Max file size 5 MB.</span>
                            </label>
                        </b-form-group>

                        <div style="margin-top: 20px;margin-bottom:20px">
                            <div
                                v-for="(error, idx) in licence.error.errors" :key="idx"
                            >
                    <span class="help-block invalid-feedback"
                          v-if="idx.startsWith('licence_files')">
                          {{ error[0] }}
                      </span>
                            </div>
                        </div>


                        <b-row>
                            <div
                                class="up-box d-flex mr-2 ml-2"
                                v-for="(file, idx2) in licence.licence_files"
                                :key="'ins-file' + idx + '-' + idx2"
                            >
                                <a :href="file.signed_url" target="_blank">
                                    <p class="mb-0">{{ file.name }}</p>
                                </a>
                                <SvgIcons
                                    v-if="licence.licence_status != 'verified'"
                                    icon="insurance-document-close"
                                    svgClass="ml-2"
                                    style="margin-top: 2px"
                                    @click.native="
                          removeLicenceMedia(file);
                          licence.licence_files.splice(
                            licence.licence_files.indexOf(file),
                            1
                          );
                        "
                                />
                            </div>
                        </b-row>
                    </b-col>
                    <hr class="w-100 mt-2 mb-3">
                </div>

                <div class="btns-action">
                    <div class="back-step">
                        <b-button
                            :disabled="form.busy"
                            type="button"
                            variant="outline-primary"
                            class="back-btn"
                            @click="$router.go(-1)"
                        >
                            Back
                        </b-button>
                    </div>

                    <b-button
                        :to="{
                    name: 'register-contractor',
                    params: { step: 4 },
                  }"
                        :disabled="form.busy"
                        type="button"
                        class="skip-btn mr-4 ml-sm-auto"
                        variant="outline-warning"
                    >Licence is not required
                    </b-button>

                    <b-button
                        :disabled="form.busy"
                        type="submit"
                        variant="primary"
                        class="btn-grad"
                    >Next
                    </b-button
                    >
                </div>
            </b-form>
        </div>
    </register-container>
</template>

<script>
import {Form, HasError} from "vform";
import SideBar from "../includes/SideBar.vue";
import Swal from "sweetalert2";
import FooterComponent from "../../../../pages/includes/FooterComponent.vue";
import SvgIcons from "@frontendPages/includes/SvgIconsComponent.vue";
import RegisterContainer from "./RegisterContainer.vue";

Vue.component(HasError.name, HasError);

export default {
    props: ["step", "sidebarListLinks"],
    components: {
        RegisterContainer,
        FooterComponent,
        SideBar,
        SvgIcons,
    },
    data() {
        return {
            form: new Form({
                licences: [],
            }),
            licenceTypes: [
                {value: "", text: "Choose", disabled: true},
                {value: "trade_work", text: "Trade Work"},
                {value: "security", text: "Master Licence"},
                {value: "asbestos_and_high_risk", text: "Asbestos & High Risk"},
                {value: "pesticide", text: "Pesticide licence and permit"},
                {value: "fire_and_safety", text: "FPAA Accreditation"},
                {value: "other", text: "Other"},
            ],
        };
    },
    mounted() {
        this.fetchFormData();
    },
    methods: {
        fetchFormData() {
            this.$root.$data.bsLoader = true;
            axios.post("api/contractor/license/getDetails").then((response) => {
                if (response.data.license === "empty") {
                    //Redirecting into business page if business is not created
                    this.$router.push({
                        name: "register-contractor",
                        params: {step: 2},
                    });
                } else {
                    if (response.data.licences.length > 0) {
                        this.form.licences = [];
                        response.data.licences.forEach((licence, index) => {
                            this.form.licences.push({
                                id: licence.id,
                                licence_type: licence.licence_type,
                                licence_number: licence.licence_number,
                                licence_files: licence.media,
                                licence_status: licence.licence_status,
                                error: {
                                    errors: {},
                                },
                            });
                        });
                    } else {
                        this.addNewLicence();
                    }
                }
                this.$root.$data.bsLoader = false;
            }).catch((err) => {
                this.$root.$data.bsLoader = false;
            });
        },

        // formSubmitted() {
        //   this.form.post("api/contractor/license/updateOrCreate").then(() => {
        //     this.$router.push({
        //       name: "register-contractor",
        //       params: { step: 4 },
        //     });
        //   });
        // },

        formSubmitted() {
            this.$root.$data.bsLoader = true;
            const orderPromises = this.form.licences.map((licence, index) => {
                var data = new FormData();
                data.append("id", licence.id);
                data.append("licence_type", licence.licence_type);
                data.append("licence_number", licence.licence_number);

                for (var i = 0; i < licence.licence_files.length; i++) {
                    if (licence.licence_files[i] instanceof File) {
                        data.append("licence_files[]", licence.licence_files[i]);
                    }
                }

                return axios
                    .post("api/contractor/license/updateOrCreate2", data, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((response) => {
                        this.form.licences[index].error.errors = {};
                        this.$root.$data.bsLoader = false;
                    })
                    .catch((error) => {
                        this.form.errors = error.response.data;
                        if (error.response?.data?.errors) {
                            this.form.licences[index].error = error.response.data;
                        }
                        this.$root.$data.bsLoader = false;
                    });
            });

            Promise.all(orderPromises).then((results) => {
                if (!Object.keys(this.form.errors.errors).length > 0) {
                    this.$router.push({
                        name: "register-contractor",
                        params: {step: 4},
                    });
                }
            });
        },

        addNewLicence() {
            this.form.licences.push({
                id: "",
                licence_type: "",
                licence_number: "",
                licence_files: [],
                error: {
                    errors: {},
                },
            });
        },

        attachLicenceFiles: function (event, attachFilesTo, licence_id) {
            this.$root.$data.bsLoader = true;
            if (!event.target.files.length) return;
            var input = event.target.files;

            input &&
            _.forEach(input, (file) => {
                attachFilesTo.push(file);
            });
            this.$root.$data.bsLoader = false;
        },

        removeLicenceMedia(file) {
            if (file.uuid) {
                this.$root.$data.bsLoader = true;
                axios
                    .post("api/contractor/license/deleteMedia", {file: file.uuid})
                    .then((response) => {
                        Swal.fire({
                            title: "File Deleted Successfully.",
                            icon: "success",
                            timer: 3000,
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                        });
                        this.$root.$data.bsLoader = false;
                    }).catch((err) => {
                    this.$root.$data.bsLoader = false;
                });
            }
        },

        deleteLicence(licence) {
            this.$root.$data.bsLoader = true;
            axios
                .post("api/contractor/license/deleteLicense", {
                    licence_id: licence.id,
                })
                .then((response) => {
                    this.form.licences.splice(this.form.licences.indexOf(licence), 1);
                    Swal.fire({
                        title: "Licence Deleted Successfully.",
                        icon: "success",
                        timer: 3000,
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                    });
                    this.$root.$data.bsLoader = false;
                }).catch((err) => {
                this.$root.$data.bsLoader = false;
            });
        },
    },
};
</script>
